import { Action } from "@ngrx/store";
import { type DigitalCardProfileItem } from "./digital-cards.interface";

export const GET_DIGITAL_CARD_PROFILES = "GET_DIGITAL_CARD_PROFILES";
export const GET_DIGITAL_CARD_PROFILES_SUCCESS =
  "GET_DIGITAL_CARD_PROFILES_SUCCESS";
export const GET_DIGITAL_CARD_PROFILES_FAILURE =
  "GET_DIGITAL_CARD_PROFILES_FAILURE";

export const GET_DIGITAL_CARD_EMPLOYEE_PROFILES =
  "GET_DIGITAL_CARD_EMPLOYEE_PROFILES";
export const GET_DIGITAL_CARD_EMPLOYEE_PROFILES_SUCCESS =
  "GET_DIGITAL_CARD_EMPLOYEE_PROFILES_SUCCESS";
export const GET_DIGITAL_CARD_EMPLOYEE_PROFILES_FAILURE =
  "GET_DIGITAL_CARD_EMPLOYEE_PROFILES_FAILURE";

export const DELETE_DIGITAL_CARD_PROFILE = "DELETE_DIGITAL_CARD_PROFILE";
export const DELETE_DIGITAL_CARD_PROFILE_SUCCESS =
  "DELETE_DIGITAL_CARD_PROFILE_SUCCESS";
export const DELETE_DIGITAL_CARD_PROFILE_FAILURE =
  "DELETE_DIGITAL_CARD_PROFILE_FAILURE";

export const SET_DEFAULT_DIGITAL_CARD_PROFILE =
  "SET_DEFAULT_DIGITAL_CARD_PROFILE";
export const SET_DEFAULT_DIGITAL_CARD_PROFILE_SUCCESS =
  "SET_DEFAULT_DIGITAL_CARD_PROFILE_SUCCESS";
export const SET_DEFAULT_DIGITAL_CARD_PROFILE_FAILURE =
  "SET_DEFAULT_DIGITAL_CARD_PROFILE_FAILURE";

export class GetDigitalCardProfilesAction implements Action {
  readonly type = GET_DIGITAL_CARD_PROFILES;

  constructor(public payload: { templatesOnly: boolean; mine: boolean }) {}
}

export class GetDigitalCardProfilesSuccessAction implements Action {
  readonly type = GET_DIGITAL_CARD_PROFILES_SUCCESS;

  constructor(public payload: DigitalCardProfileItem[]) {}
}

export class GetDigitalCardProfilesFailureAction implements Action {
  readonly type = GET_DIGITAL_CARD_PROFILES_FAILURE;

  constructor(public payload: unknown) {}
}

export class GetDigitalCardEmployeeProfilesAction implements Action {
  readonly type = GET_DIGITAL_CARD_EMPLOYEE_PROFILES;

  constructor(public payload: { templateId: string; mine: boolean }) {}
}

export class GetDigitalCardEmployeeProfilesSuccessAction implements Action {
  readonly type = GET_DIGITAL_CARD_EMPLOYEE_PROFILES_SUCCESS;

  constructor(
    public payload: {
      templateId: string;
      profiles: DigitalCardProfileItem[];
      readiness: "pending" | "ready";
      expected?: number;
      synced?: number;
    },
  ) {}
}

export class GetDigitalCardEmployeeProfilesFailureAction implements Action {
  readonly type = GET_DIGITAL_CARD_EMPLOYEE_PROFILES_FAILURE;

  constructor(public payload: { templateId: string; error: unknown }) {}
}

export class DeleteDigitalCardProfileAction implements Action {
  readonly type = DELETE_DIGITAL_CARD_PROFILE;

  constructor(public payload: string) {}
}

export class DeleteDigitalCardProfileSuccessAction implements Action {
  readonly type = DELETE_DIGITAL_CARD_PROFILE_SUCCESS;

  constructor(public payload: string) {}
}

export class DeleteDigitalCardProfileFailureAction implements Action {
  readonly type = DELETE_DIGITAL_CARD_PROFILE_FAILURE;

  constructor(public payload: unknown) {}
}

export class SetDefaultDigitalCardProfileAction implements Action {
  readonly type = SET_DEFAULT_DIGITAL_CARD_PROFILE;

  constructor(public payload: string) {}
}

export class SetDefaultDigitalCardProfileSuccessAction implements Action {
  readonly type = SET_DEFAULT_DIGITAL_CARD_PROFILE_SUCCESS;

  constructor(public payload: string) {}
}

export class SetDefaultDigitalCardProfileFailureAction implements Action {
  readonly type = SET_DEFAULT_DIGITAL_CARD_PROFILE_FAILURE;

  constructor(public payload: unknown) {}
}

export type DigitalCardsActions =
  | GetDigitalCardProfilesAction
  | GetDigitalCardProfilesSuccessAction
  | GetDigitalCardProfilesFailureAction
  | GetDigitalCardEmployeeProfilesAction
  | GetDigitalCardEmployeeProfilesSuccessAction
  | GetDigitalCardEmployeeProfilesFailureAction
  | DeleteDigitalCardProfileAction
  | DeleteDigitalCardProfileSuccessAction
  | DeleteDigitalCardProfileFailureAction
  | SetDefaultDigitalCardProfileAction
  | SetDefaultDigitalCardProfileSuccessAction
  | SetDefaultDigitalCardProfileFailureAction;
